const React = require('react');
const createReactClass = require('create-react-class');
const _ = require('lodash');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Scheduling = require('./Scheduling');
const Status = require('./Status');
const ModelStore = require("../../../install/fuzzy-reaction/lib/stores/ModelStore");
const MessageActions = require('../../actions/MessageManagementActions');
const PropTypes = require('prop-types');
const {withRouter} = require("react-router-dom");

const BaseMessages = createReactClass({
    displayName: 'BaseMessages',

    propTypes: {
        messagesType: PropTypes.string.isRequired,
    },

    messagesStore: ModelStore,
    resourceAction: ResourceActions,

    getInitialState: function () {
        /**
         * Set up resource actions
         */
        this.messagesStore = this.props.messagesType === 'email' ? require('../../stores/EmailMessagesStore') : require('../../stores/PushMessagesStore');
        this.resourceAction = this.props.messagesType === 'email' ? new ResourceActions('email-messages') : new ResourceActions('push-messages');

        return {
            showArchived: false,
            openArchiveModal: false,
            currentPageData: [],
            workingResource: {},
        }
    },

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            sort: {
                id: 'desc'
            },
            pagination: {
                per_page: '50'
            },
            other: {}
        },
        dataNode: 'data',
        refresh: 'list'
    },

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Add or remove archived messages.
        this.filterArchived();

        // Merge modifiers with already present ones
        if (typeof modifiers !== 'undefined' && typeof modifiers.filters !== 'undefined') {
            this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        }

        this.resourceAction.listResource(this.getOptions);
    },

    filterArchived: function () {
        const checkbox = document.getElementById(this.archivedCheckbox)

        if (checkbox.checked) {
            this.getOptions.modifiers.other.show_deleted = true;
        } else {
            delete this.getOptions.modifiers.other.show_deleted;
        }
    },

    formKey: 'addMessage',

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestTableData();

        this.changeListener = this._onChange;
        this.messagesStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        this.messagesStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: this.messagesStore.getResourceListData()
        });
    },

    /**
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'edit':
            case 'view':
                this.props.history.push(`${this.props.messagesType === 'email' ? '/email-messages' : '/push-messages'}/${resource.id}`);
                break;
            case 'archive':
                this.setState({
                    openArchiveModal: true,
                    workingResource: {id: resource.id},
                });
                break;
            case 'restore':
                this.updateMessage({id: resource.id, deleted_at: null, status: Status.DRAFT});
                break;
            case 'start sending':
                this.updateMessage({id: resource.id, status: Status.PENDING});
                break;
            case 'stop sending':
                this.updateMessage({id: resource.id, status: Status.PAUSED});
                break;
            case 'create':
                // Clear stored message for a fresh start
                MessageActions.clearStoredMessage();

                this.props.history.push(`${this.props.messagesType === 'email' ? '/email-messages/' : '/push-messages/'}`);
                break;
        }
    },

    /**
     * Fire the update message action
     */
    updateMessage: function (message) {
        this.resourceAction.updateResource(message, this.getOptions);
    },

    /**
     * Fire the archive message action
     */
    archiveMessage: function () {
        this.resourceAction.deactivateResource(this.state.workingResource, this.getOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openArchiveModal: false,
            workingResource: {}
        });
    },

    tableKeys: {
        'ID': 'id',
        'Created': 'created_at',
        'Updated': 'updated_at',
        'Name': 'name',
        'Status': 'status',
        'Scheduling': 'scheduling',
        'Start At': 'start_at',
        'Stop At': 'stop_at'
    },

    archivedCheckbox: 'archivedCheckbox',

    render: function () {
        const tableOptions = {
            actionableRows: true,
            actions: ['stop sending:danger', 'edit:primary', 'archive:danger'],
            actionsCallback: this.handleAction,
            sortable: ['id', 'created_at', 'updated_at', 'name', 'status', 'scheduling', 'start_at', 'stop_at'],
            mutators: {
                status: value => Status.valueToLabel(value),
                scheduling: value => Scheduling.valueToLabel(value)
            },
            emptyText: 'No messages found.',
            hideSpinner: true
        };
        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">{this.props.messagesType === 'email' ? 'Email' : 'Push'} Messages</h1>
                        </Column>

                        <Column grid="lg" size="2">
                            <div className="page-header">
                                <label style={{marginTop: '6px'}}>
                                    <input type="checkbox" id={this.archivedCheckbox} onChange={this.requestTableData}
                                           value="1"/>
                                    <span className="checkbox-material">
                                        <span className="check"/>
                                    </span>
                                    <span className="checkbox-label">Show archived messages</span>
                                </label>
                            </div>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['id', 'name', 'subject', 'preview', 'html', 'text']}/>
                            </div>
                        </Column>
                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Messages'} options={tableOptions}/>

                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>
                        </Column>
                    </Row>
                </div>

                <AddAction createResource={this.handleAction}/>

                <Modal openWhen={this.state.openArchiveModal}
                       title="Archive Message?" closeText="Close"
                       saveText="Archive" afterClose={this.closeModal}
                       beforeSave={this.archiveMessage}
                       afterSave={this.closeModal}>
                    <p>You’re about to archive a message. In order to restore it, you will have to show archived
                        messages
                        and then click the 'Restore' button, at which point the message will be restored into a Draft
                        state.</p>
                    <p>Continue with archiving this message?</p>
                </Modal>
            </div>
        )
    },
});

module.exports = withRouter(BaseMessages);
